import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars, faTimes, faSyringe, faDog,
  faPaw, faGift, faUserShield, faWalking,
  faHandshake, faTrash
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, NavLink } from 'react-router-dom';
import { routes } from '../../../config/utility';
import { motion } from 'framer-motion';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const menuItems = [
    { icon: faSyringe, label: 'Pet Allergy', path: routes.pet_allergy },
    { icon: faDog, label: 'Pet Breed', path: routes.pet_breed },
    { icon: faPaw, label: 'Pet Type', path: routes.pet_type },
    { icon: faGift, label: 'Promo Code', path: routes.promo_code },
    { icon: faUserShield, label: 'Membership', path: routes.membership },
    { icon: faWalking, label: 'Walk Tool', path: routes.walk_tool },
    { icon: faHandshake, label: 'Partner', path: routes.partner },
    { icon: faTrash, label: 'Account Deletions', path: routes.account_deletion_admin },
  ];

  return (
    <div className="h-full">
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: isOpen ? 260 : 70 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className={`
          bg-gradient-to-br from-tblue to-gray-900 
          flex flex-col py-10 px-4 sm:px-4 
          rounded-r-3xl lg:rounded-3xl 
          h-full sm:h-auto overflow-hidden
          relative
        `}
      >
        {/* Close Button for Mobile */}
        <button
          onClick={toggleSidebar}
          className="lg:hidden absolute top-4 right-4 text-white p-2"
        >
          <FontAwesomeIcon icon={faTimes} className="text-xl" />
        </button>

        <button
          onClick={toggleSidebar}
          className="hidden sm:block absolute top-4 right-4 text-white p-2"
        >
          <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </button>

        {/* Logo Section */}
        <motion.div
          className={`flex items-center justify-center mb-14 
            transition-opacity duration-300 
            ${isOpen ? 'opacity-100' : 'opacity-0'}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: isOpen ? 1 : 0 }}
        >
          <img src="/assets/paw-logo.png" alt="Pawdash Logo" className="w-12 h-12 shadow-lg" />
        </motion.div>

        {/* Menu Items */}
        <ul className="space-y-6 sm:space-y-8">
          {menuItems.map((item, index) => (
            <motion.li
              key={index}
              className="relative group"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <NavLink
                to={item.path}
                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                className={({ isActive }) =>
                  `flex items-center space-x-4 px-3 py-2 text-left text-sm tracking-wide font-medium 
                  relative group transition-all duration-300
                  ${isActive
                    ? 'text-white bg-white/10 rounded-lg'
                    : 'text-ash hover:text-white hover:bg-white/5 rounded-lg'
                  }`
                }
              >
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: "spring", stiffness: 400 }}
                  className="flex-shrink-0"
                >
                  <FontAwesomeIcon icon={item.icon} className="text-lg" />
                </motion.div>

                {isOpen && (
                  <span className="truncate transition-transform duration-300 group-hover:translate-x-1">
                    {item.label}
                  </span>
                )}
              </NavLink>

              {location.pathname === item.path && (
                <motion.div
                  layoutId="activeIndicator"
                  className="absolute -left-3 top-0 h-full w-1 bg-white rounded-r-lg"
                />
              )}
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </div>
  );
};

export default Sidebar;
